<template>
  <main>
    <MainNavigation :page="page" :hideNavigation="hideNavigation">
      <template #before-sidebar>
        <slot name="before-sidebar"></slot>
      </template>
      <template #after-sidebar>
        <slot name="after-sidebar"></slot>
      </template>
    </MainNavigation>

    <slot name="before-magento-content"></slot>
    <slot v-if="!emptyConfig">
      <MagentoContent v-if="page"
        v-bind="$props"

        @toggle-color-swatch="swatch = !swatch"
      >
        <template #top-left-content>
          <slot name="top-left-content"></slot>
        </template>
      </MagentoContent>
      <div v-else class="flex justify-center items-center grow">
        <slot name="empty"></slot>
      </div>
    </slot>
    <div v-else class="grow relative flex justify-center">
      <div class="light-grid absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]" style="background-position: 10px 10px;"></div>

      <TemplatesManager
        class="max-w-[100.25rem] w-full flex flex-col border border-gray-200 overflow-hidden rounded-lg"

        message="You can select default template created by the admin. You can also create your own custom templates later."
        inner-max-width="max-w-[77.625rem]"
        :show-inner-shadow="true"
        :remove-close-button="true"
        :value="true"
      >
        <div class="shadow-inner absolute z-10 bg-transparent rounded-lg pointer-events-none left-0 top-0 w-full h-full"></div>
      </TemplatesManager>
    </div>

    <slot name="before-color-swatch"></slot>
<!--    <transition @enter="enter" @leave="leave" :disabled="resetingColorSwatch">
      <div v-if="swatch && page" class="flex">
        <StylesConfig
          class="w-96 shrink-0 border-l border-gray-200"
          @reset-color-changes="resetColorChanges"
        />
      </div>
    </transition>-->
  </main>
</template>

<script>

import { mapGetters } from 'vuex'

import MagentoContent from './BlocksSidebar/MagentoContent.vue'
import MainNavigation from "@/components/SideEditor/MainNavigation/MainNavigation"
import TemplatesManager from "@/components/SideEditor/TemplatesManager/TemplatesManager"

// import StylesConfig from "@/components/SideEditor/BlockConfiguration/StylesConfig/StylesConfig"
import TransitionFunctionConstructor from "@/mixins/transitionFunctionConstructor"

export default {
  props: {
    iframeTarget: {
      type: String,
    },
    page: {
      type: String,
    },
    currentPage: String,
    hideNavigation: Boolean,
    overrides: Array,
  },
  mixins: [TransitionFunctionConstructor("enter", "leave", "width", "resetingColorSwatch")],
  components: {
    MagentoContent,
    MainNavigation,
    TemplatesManager,
  },
  created() {
    this.updatePage()
    this.updateTarget()
    this.updateOverrides()
  },
  data() {
    return {
      swatch: false,
      resetingColorSwatch: false,
    }
  },
  methods: {
    updateTarget() {
      this.$store.commit("editor/iframeTarget", this.currentPage || this.iframeTarget)
    },
    updatePage() {
      this.$store.commit("editor/page", this.page)
    },
    updateOverrides() {
      this.$store.commit("editor/overrides", this.overrides)
    },
  },
  computed: {
    ...mapGetters({
      emptyConfig: 'editor/emptyConfig',
    }),
  },
  watch: {
    page() {
      this.updatePage()
    },
    overrides() {
      this.updateOverrides()
    },
    iframeTarget() {
      this.updateTarget()
    },
    currentPage() {
      this.updateTarget()
    },
  },
}

</script>
